import useAsyncData from "../../../../hooks/use-async-data";
import taxiCorporationService from "../../taxi-corporation.service";
import TaxiCorporationDriverPlan from "./taxi-corporation-driver-plan";
import TaxiCorporationDriverPlanParams from "./taxi-corporation-driver-plan-params";

const useTaxiCorporationDriverPlan = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<TaxiCorporationDriverPlan>({ entries: [] });

  const load = async (
    params: TaxiCorporationDriverPlanParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiCorporationDriverPlan =
        await taxiCorporationService.getDriverPlan(params, signal);

      setData(taxiCorporationDriverPlan);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useTaxiCorporationDriverPlan;
